function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zbDialog from '@/components/zbDialog';
export default {
  components: {
    zbDialog: zbDialog
  },
  props: {
    row: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    column: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      filesDialog: false,
      filesList: [],
      previewUrl: '',
      previewDialog: false
    };
  },
  methods: {
    formatUrl: function formatUrl(url) {
      return process.env.VUE_APP_BASE_API + url;
    },
    downField: function downField(url, fileName) {
      window.open(process.env.VUE_APP_BASE_API + url + '?fileName=' + fileName);
    },
    openDetailDialog: function openDetailDialog(row) {
      this.$emit('openDetailDialog', row);
    },
    openFilesDialog: function openFilesDialog(list) {
      this.filesDialog = true;
      this.filesList = _toConsumableArray(list);
    },
    numberToCurrencyNo: function numberToCurrencyNo(value) {
      if (!value) return 0;
      // 获取整数部分
      var intPart = Math.trunc(value);
      // 整数部分处理，增加,
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      var floatPart = '';
      // 将数值截取为小数部分和整数部分
      var valueArray = value.toString().split('.');
      if (valueArray.length === 2) {
        // 有小数部分
        floatPart = valueArray[1].toString(); // 取得小数部分
        return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    previewImg: function previewImg(url) {
      this.previewUrl = url;
      this.previewDialog = true;
    }
  }
};